module.exports = __webpack_public_path__ + "static/media/160.e98b1ade.png";